import script from "./TargetAreaKestrel.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetAreaKestrel.vue?vue&type=script&setup=true&lang=js"

import "./TargetAreaKestrel.vue?vue&type=style&index=0&id=09528694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09528694"]])

export default __exports__